export class Availability {

    static hasIncompleteAvailability (availability) {
        const hasAvailalibity = availability !== null;
        const hasEmptyTime = (availability || []).some(({ times }) => {
            return times.some((time) => (time.start && !time.end) || (!time.start && time.end));
        });

        return hasAvailalibity && hasEmptyTime;
    }

    static getValidAvailability (availability) {
        const availabilities = (availability || []).map((availability) => {
            const times = availability.times.filter((time) => time.start && time.end && time.start !== time.end);
            availability.times = times;
            return availability
        });

        const filteredAvailabilities = availabilities.filter((availability) => availability.times.length > 0);
        return filteredAvailabilities.length > 0 ? filteredAvailabilities : null;
    }

}